import { render, staticRenderFns } from "./newpatient.vue?vue&type=template&id=8d55043c&"
import script from "./newpatient.vue?vue&type=script&lang=js&"
export * from "./newpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports